export enum EShareTable {
  VIDEO = 'Video',
  CAMPAIGN_SUBMISSION = 'CampaignSubmission'
}
